module.exports = __webpack_public_path__ + "static/media/banner-2.272889f0.jpeg";